const faqNo = {
    title: 'FAQ',
    actions: {
        contact: 'Kontakt oss',
        readMore: 'Les mer',
    },
    sections: {
        about: 'Om Mundu',
        terms: 'Begreper',
        guide: 'Veiledning',
        account: 'Slette brukere eller avslutte abonnement',
    },
    entries: {
        '1': {
            title: 'Hva er Mundu?',
            content:
                'Forskning viser at riktig bruk av personlig musikk kan ha en god helseeffekt på personer med demens. Personlig musikk kan gi dempet angst, uro, depresjon og stimulere til bedre hukommelse. Bedre hukommelse gir også grobunn for bedre toveis samtaler og skaper gode øyeblikk sammen med pårørende. Personlig musikk satt sammen med bilder som betyr noe for personen med demens kan også gi en enda mer kraftfull, positiv virkning og stimulere til gode samtaler. Dette er essensen av Mundu.',
        },
        '2': {
            title: 'Hva betyr Mundu?',
            content:
                'Mundu er et gammelt norrønt ord som fortsatt brukes på Island. Navnet settes i konteksten om hukommelse, som for eksempel «Husker du den gangen..?».',
        },
        '3': {
            title: 'Hvordan virker Mundu?',
            content:
                'Mundu bygger på dokumentert musikkterapeutisk forskning som viser at preferansebasert musikk kan dempe angst, uro og depresjon, og stimulere til bedre hukommelse. Målet er å skape gode øyeblikk – alene eller sammen med andre – på institusjon, dagsenter eller hjemme. Mundu gir musikkterapeuter og helsepersonell et digitalt verktøy for å opprette brukere, invitere pårørende til samarbeid samt lage og sende videoer som kombinerer personlig musikk og betydningsfulle bilder.',
        },
        '4': {
            title: 'Hvem passer Mundu best for?',
            content:
                'Mundu er primært utviklet for personer med mild til moderat demens, men kan også ha effekt for andre grupper innen psykisk helse fordi musikk for helse kan virke positivt på flere. Vil noen teste Mundu i et annet fagområde, ta kontakt.',
        },
        '5': {
            title: 'Hvem har laget Mundu?',
            content:
                'Mundu er et norsk produkt med utspring fra NKS Olaviken alderspsykiatriske sykehus. Idéen ble videreført til norske gründere innen musikkteknologi, og Olaviken er en nær samarbeidspartner. Tjenesten er utviklet og validert sammen med musikkterapeuter og helsepersonell.',
        },
        '6': {
            title: 'Hva er en bruker?',
            content:
                'En bruker er en beboer, pasient, hjemmeboende eller besøkende person med demens på dagsenter.',
        },
        '7': {
            title: 'Hva er en pårørende?',
            content:
                'En pårørende er en eller flere personer som har familiær eller nær tilknytning til brukeren.',
        },
        '8': {
            title: 'Hva er en superbruker?',
            content:
                'Superbrukeren er personen i institusjonen som har det overordnede administrative ansvaret. Superbrukeren kan gi ansatte tilgang, slette brukere, pårørende og ansatte samt administrere kundeforholdet.',
        },
        '9': {
            title: 'Hva er en ansatt?',
            content:
                'En ansatt er personen som har direkte kontakt med brukeren.',
        },
        '10': {
            title: 'Hva er en forbindelse?',
            content:
                'Du oppretter en forbindelse til brukeren i webklienten. Når forbindelsen er opprettet, kan du lage en video.',
        },
        '11': {
            title: 'Hva er en video?',
            content:
                'En video består av musikk brukeren har et nært forhold til, kombinert med bilder fra brukerens liv. Når videoen er laget og sendt, ligger den klar i appen til glede for brukeren.',
        },
        '12': {
            title: 'Hva er en webklient?',
            content:
                'Webklienten er verktøyet superbrukere og ansatte bruker for å opprette brukere, kartlegge musikalsk livshistorie, invitere pårørende og lage videoer.',
        },
        '14': {
            title: 'Hvordan går jeg fram i Mundu?',
            content:
                'Opprett først en forbindelse til brukeren som skal motta videoen. Du blir geleidet gjennom hele prosessen, legger inn musikalsk livshistorie og inviterer pårørende til samarbeid. Når pårørende deler bilder, blir du varslet. Tips: Be gjerne om korte beskrivelser til hvert bilde. Du kan ikke lage video før bilder er delt. Kartlegg brukerens musikksmak og klikk deretter på «Lag ny video» for en trinnvis veiledning.',
        },
        '15': {
            title: 'Hvordan lager jeg en video?',
            content:
                'På førstesiden etter innlogging finner du ikonet «Lag ny video». Når du klikker startes en enkel, trinnvis veiledning. Får du det ikke til, har du ikke gjort noe feil – gi oss heller tilbakemelding på hva som var uklart.',
        },
        '16': {
            title: 'Tar det lang tid å lage en video?',
            content:
                'Mundu er laget for at du skal bruke minst mulig tid. Skulle prosessen ta lenger tid enn ønsket, vil vi gjerne vite hvorfor slik at vi kan forbedre tjenesten.',
        },
        '17': {
            title: 'Hva er et kartleggingsskjema?',
            content:
                'Kartleggingsskjemaet hjelper deg å lære brukerens musikalske livshistorie. Fyll det ut sammen med bruker eller pårørende for å velge riktig musikk senere.',
        },
        '18': {
            title: 'Hvor mange brukere kan jeg lage video for?',
            content:
                'Antall brukere styres av lisensene arbeidsgiver betaler for. Trenger dere flere lisenser, ta kontakt.',
        },
        '19': {
            title: 'Hvor mange ansatte kan jeg invitere?',
            content:
                'Du kan invitere et ubegrenset antall ansatte til samarbeid.',
        },
        '20': {
            title: 'Kan videoen spilles av uten wifi?',
            content:
                'Ja, videoen kan spilles av offline i inntil 30 dager. Nettbrettet må være koblet til wifi eller mobilt nett første gang videoen lastes ned.',
        },
        '21': {
            title: 'Hva hvis nettbrettet er offline i mer enn 30 dager?',
            content:
                'Av hensyn til rettighetshavere må nettbrett kobles til internett minst hver 30. dag. Etter 30 dager uten tilkobling må nettbrettet på nett igjen for å få tilgang.',
        },
        '22': {
            title: 'Kan flere brukere dele ett nettbrett?',
            content:
                'Ja, flere brukere kan bruke samme nettbrett. Hver bruker har eget brukernavn og passord. Husk å logge ut for å ivareta personvernet.',
        },
        '23': {
            title: 'Må jeg logge ut en bruker før en ny kan logge inn?',
            content:
                'Ja, du må logge ut for at neste bruker skal kunne ta over nettbrettet.',
        },
        '24': {
            title: 'Hvordan fungerer appen for pårørende?',
            content:
                'Når du lager video for en bruker, inviterer du pårørende til samarbeid. De får e-postinvitasjon og veiledning for å dele digitale bilder direkte til brukerens bildebibliotek via appen eller – snart – en webportal.',
        },
        '25': {
            title: 'Får jeg varsel når pårørende deler bilder?',
            content:
                'Ja, du får automatisk e-post når nye bilder er delt og klare til bruk.',
        },
        '26': {
            title: 'Får pårørende varsel når jeg lager video?',
            content:
                'Ja, pårørende får automatisk beskjed når du har delt en ferdig video, slik at de holdes oppdatert.',
        },
        '27': {
            title: 'Kan jeg dele video med flere forbindelser?',
            content:
                'Ikke i dagens versjon. Gi oss gjerne tilbakemelding hvis du trenger å dele med flere brukere som ikke bryter personvernet.',
        },
        '28': {
            title: 'Har dere et bibliotek med generelle bilder?',
            content:
                'Vi støtter kun private bilder, fordi erfaring og fagpersonell viser at dette gir best effekt. Gi oss gjerne tilbakemelding hvis dere ønsker generelle bilder.',
        },
        '29': {
            title: 'Hva gjør jeg ved feilmelding?',
            content:
                'Prøv på nytt. Ved gjentatte feil, ta kontakt med superbrukeren som ga deg tilgang. Vi logger feil og retter dem så raskt vi kan.',
        },
        '30': {
            title: 'Hvor kommer musikken fra?',
            content: 'Mundu lisensierer musikkbiblioteket fra 7Digital.',
        },
        '31': {
            title: 'Kommer det en ekstra TONO-regning?',
            content:
                'Nei, lisensen dekker musikkbruken. Mundu har avtaler med TONO og rettighetshavere via GRAMO.',
        },
        '32': {
            title: 'Kan jeg koble Mundu til Spotify?',
            content:
                'Nei, Mundu kan ikke kobles til andre strømmetjenester, men har tilsvarende musikkutvalg og integrerte Spotify-spillelister via 7Digital.',
        },
        '33': {
            title: 'Jeg finner ikke musikken jeg søker. Hvorfor?',
            content:
                'Du har tilgang til det meste av tilgjengelig digital musikk, men noen titler kan mangle. Sjekk at artist eller låtnavn er skrevet riktig.',
        },
        '34': {
            title: 'Kan jeg legge inn filmklipp i videoen?',
            content:
                'Det støttes ikke per i dag. Gi oss beskjed hvis behovet er stort.',
        },
        '35': {
            title: 'Kan jeg styre rekkefølgen på sangene?',
            content:
                'Ja, dra og slipp sangene i ønsket rekkefølge på PC eller hold fingeren på sangen på nettbrett for å flytte den.',
        },
        '36': {
            title: 'Kan jeg styre rekkefølgen på bildene?',
            content:
                'Ja, dra og slipp bildene i ønsket rekkefølge, eller hold fingeren på et bilde på nettbrett for å flytte det.',
        },
        '37': {
            title: 'Hvor mange bilder bør en video ha?',
            content:
                'Mundu anbefaler et intervall basert på total spilletid. Nederste nivå gir ca. 30 sekunder per bilde, mens øvre nivå gir ca. 12 sekunder.',
        },
        '38': {
            title: 'Kan jeg lagre et utkast?',
            content:
                'Ja, hvis du må avbryte arbeidet, lagres fremdriften til neste innlogging.',
        },
        '39': {
            title: 'Kan pårørende dele film i stedet for bilder?',
            content: 'Ikke foreløpig. Gi oss beskjed dersom dette er ønskelig.',
        },
        '40': {
            title: 'Kan jeg slette en forbindelse til en bruker?',
            content:
                'Ja, superbruker kan slette en forbindelse – for eksempel ved dødsfall eller når tjenesten ikke lenger er relevant. All data slettes fra serverne innen 90 dager.',
        },
        '41': {
            title: 'Hva skjer med videoene hvis jeg bytter bruker?',
            content:
                'Ved bytte av bruker kan ikke eksisterende videomateriale beholdes av hensyn til rettigheter. Det slettes fra serverne innen 90 dager.',
        },
        '42': {
            title: 'Må vi kjøpe flere lisenser når vi bytter bruker?',
            content:
                'Nei, lisensgrunnlaget følger antallet dere betaler for – ikke hvilken person som bruker lisensen. Dere kan bytte bruker så ofte dere vil innenfor lisensrammen.',
        },
        '43': {
            title: 'Kan jeg forhåndsvise videoen før den deles?',
            content:
                'Ja, du kan forhåndsvise videoen i siste steg og gjøre eventuelle endringer før du deler.',
        },
        '44': {
            title: 'Kan jeg spole i videoen på nettbrettet?',
            content: 'Ikke ennå, men funksjonen er under utvikling.',
        },
        '45': {
            title: 'Kan jeg pause videoen og fortsette senere?',
            content: 'Dette støttes ikke foreløpig, men er under utvikling.',
        },
        '46': {
            title: 'Er det trygt å sende video?',
            content:
                'Videoen er kun tilgjengelig for mottakeren du velger. Mottakeren må logge inn på nettbrettet for å se den.',
        },
        '47': {
            title: 'Blir personvernet ivaretatt?',
            content: 'Ja, personvernet ivaretas i tråd med lovverket.',
        },
        '48': {
            title: 'Hvordan ivaretas sikkerheten?',
            content:
                'Mundu har nødvendige sikkerhetstiltak for å beskytte kundens interesser. Institusjoner har blant annet tofaktorautentisering.',
        },
        '49': {
            title: 'Har Mundu en veiviser i webklienten?',
            content:
                'Vi har valgt å ikke ha en veiviser i dagens versjon fordi tjenesten skal være intuitiv. Gi oss gjerne tilbakemeldinger dersom du savner veiledning et sted.',
        },
        '50': {
            title: 'Hva om brukeren ikke har pårørende?',
            content:
                'Da kan for eksempel en helsearbeider ta rollen som pårørende. Vær oppmerksom på at samme e-postadresse ikke kan brukes for flere brukere.',
        },
        '51': {
            title: 'Hvem kan slette brukere?',
            content:
                'Kun superbruker kan slette ansatte, brukere og pårørende.',
        },
        '52': {
            title: 'Kan jeg slette en bruker?',
            content: 'Kun superbruker har tilgang til å slette en bruker.',
        },
        '53': {
            title: 'Jeg er pårørende og vil slette profilen min. Hva gjør jeg?',
            content:
                'Pårørende kan slette sin profil under Innstillinger i appen.',
        },
        '54': {
            title: 'Hvordan avslutter jeg abonnementet?',
            content: 'Ta kontakt for å avslutte abonnementet.',
        },
    },
};

export default faqNo;
